module.exports = __webpack_public_path__ + "Roboto-Light.b355aea0c75c3543593a.woff";


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/assets/font/roboto/Roboto-Light.woff
// module id = ../../../../../src/assets/font/roboto/Roboto-Light.woff
// module chunks = 2